export default __webpack_public_path__ + "static/media/148.4c644842.jpg";